import type { AppFlyoutAnchorProps } from "@1js/acui-button";
import { getSizedFlyoutAnchorStyles } from "@1js/acui-button";
import type { ActionControlSize } from "@1js/acui-common";

import { getFlyoutAnchorProps } from "../../../components/RibbonControlGroupMLR/getRibbonControlGroupItemsProps";
import { getIconBasedOnSize } from "../../../ribbonIconSet";
import type { RibbonPreviewGalleryProps } from "../../RibbonControlProps";

// Add size to be able to pass through size from preview gallery
// since size isn't available on AppFlyoutAnchorProps
type AppFlyoutAnchorPropsWithSize = AppFlyoutAnchorProps & {
  size?: ActionControlSize;
};

export function convertRibbonPreviewGalleryToFlyoutAnchorProps(
  galleryProps: RibbonPreviewGalleryProps
): AppFlyoutAnchorPropsWithSize {
  const {
    flyoutAnchorProps,
    size,
    flyoutAnchorIconSet,
    id,
    disabled,
    menuLauncherLabel,
    onMenuButtonExecute,
    onAfterMenuDismiss,
    keytipProps,
    shadowRenderMenu,
  } = galleryProps;

  // Only set the specific menu props if they exist,
  // otherwise these could overwrite the same props coming from the store
  // (if they got blindly set, potentially to undefined here)
  const menuProps: Partial<AppFlyoutAnchorProps> = {};
  if (galleryProps.expandedOptions) {
    menuProps.menuDefinition = galleryProps.expandedOptions;
  }
  if (galleryProps.deferredMenuDefinition) {
    menuProps.deferredMenuDefinition = galleryProps.deferredMenuDefinition;
  }

  let props: AppFlyoutAnchorPropsWithSize = {
    type: "AppFlyoutAnchorProps",
    ...flyoutAnchorProps,
    ...menuProps,
    id,
    disabled,
    icon: getIconBasedOnSize(flyoutAnchorIconSet, size),
    label: (flyoutAnchorProps && flyoutAnchorProps.label) || menuLauncherLabel,
    onExecute: onMenuButtonExecute,
    onAfterMenuDismiss,
    keytipProps,
    shadowRenderMenu,
    persistMenu: true /* Always persist Ribbon Gallery menus */,
    size,
  };

  // It is ok to mutate the props here because we just constructed this object.
  // This is also only being done because the function requires all the props to be passed in.
  if (size) {
    props = {
      ...props,
      styles: getSizedFlyoutAnchorStyles(
        props,
        size,
        flyoutAnchorProps?.styles
      ),
      ...getFlyoutAnchorProps(size),
    };
  }

  return props;
}
